function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import wrapSchemaWidget from './wrapSchemaWidget';
import compose from '../../utils/compose';
import cs from 'classnames';
import getDisplayName from '../../getDisplayName';
import { isNumeric, isInteger, isValidNumeric } from './utils/isNumeric';
import getNumericDisplay from './utils/getNumericDisplay';
import getNumericStorage from './utils/getNumericStorage';
function isDecorated(options) {
  return !!(options.before || options.after);
}
function getInputType(format) {
  var type = 'text';
  switch (format) {
    case 'full-date':
      type = 'date';
      break;
    case 'email':
      type = 'email';
      break;
    case 'tel':
      type = 'tel';
      break;
    case 'textarea':
      type = 'textarea';
      break;
    default:
      type = 'text';
      break;
  }
  return type;
}
function getNumericSizeModifier(props, options) {
  var result;
  var _props$schema = props.schema,
    schema = _props$schema === void 0 ? {} : _props$schema;
  if (isInteger(props) && !isDecorated(options) && Number.isInteger(schema.maximum)) {
    var maximum = schema.maximum;
    if (maximum < 100) {
      result = 'two-digit-max';
    } else if (maximum < 10000) {
      result = 'four-digit-max';
    }
  }
  return result;
}

// number -> local string
function getRawValue(props) {
  if (isNumeric(props)) {
    var startValue = props.value !== undefined ? props.value : '';
    var stringValue = startValue.toString ? startValue.toString() : startValue;
    if (stringValue.length === 0) {
      return '';
    }
    var n = Number(stringValue);
    var valid = typeof n === 'number' && !Number.isNaN(n);
    return valid ? getNumericDisplay(props, n.toLocaleString()) : startValue;
  } else {
    return null;
  }
}
export function makeTextWidget(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    // For numeric input rawValue is what is displayed in the text input
    var _useState = useState(getRawValue(props)),
      _useState2 = _slicedToArray(_useState, 2),
      rawValue = _useState2[0],
      setRawValue = _useState2[1];
    useEffect(function () {
      // if user is still updating the element, don't update
      if (document.activeElement.id !== props.id) {
        setRawValue(getRawValue(props));
      }
      // disabling the eslint here because I _know_? the only change we really
      // care about recalculating the rawValue for is for the props.value change
      // despite getRawValue relying on all props
      // eslint-disable-next-line
    }, [props.id, props.value]);
    function handleChange(e, v) {
      var value = v === undefined ? e.target.value : v;
      if (isNumeric(props)) {
        setRawValue(value);
        var storageValue = value;
        if (isValidNumeric(props, value)) {
          storageValue = getNumericStorage(props, value);
        }
        props.onChange(storageValue);
      } else {
        props.onChange(value === '' ? undefined : value);
      }
    }
    function handleBlur() {
      if (isNumeric(props)) {
        var raw = isValidNumeric(props, rawValue) ? getNumericDisplay(props, rawValue) : rawValue;
        setRawValue(raw);
      }
      props.onBlur && props.onBlur(props.id, props.value);
    }
    function handleFocus() {
      props.onFocus && props.onFocus(props.id, props.value);
    }
    var className = props.className,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      schema = props.schema,
      placeholder = props.placeholder,
      _props$options = props.options,
      options = _props$options === void 0 ? {} : _props$options,
      rest = _objectWithoutProperties(props, ["className", "value", "schema", "placeholder", "options"]);
    var type = getInputType(schema.format);
    var displayValue = isNumeric(props) ? rawValue : value;
    var schemaType = schema.type;
    var numericSizeModifier = getNumericSizeModifier(props, options);
    var classNames = cs(className, _defineProperty({}, "_dm-input--".concat(schemaType), schemaType), _defineProperty({}, "_dm-input--".concat(schemaType, "--").concat(numericSizeModifier), numericSizeModifier));
    var uiOptions = Object.assign({}, options, {
      isDecorated: isDecorated(options)
    });
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, rest, {
      uiOptions: uiOptions,
      maxLength: schema.maxLength,
      minLength: schema.minLength,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      placeholder: placeholder,
      type: type,
      className: classNames,
      value: displayValue
    }));
  };
  Wrapped.displayName = "MakeTextWidget(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}
export default compose(wrapSchemaWidget, makeTextWidget);